import React from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Paper,
  Typography,
  useTheme,
} from '@mui/material';
import {
  Email as EmailIcon,
  Sms as SmsIcon,
} from '@mui/icons-material';
import { DeliveryChannel } from '../dtos/communication.dto';
import { getSectionStyles } from '../shared';

interface DeliveryMethodCardProps {
  deliveryChannels: Set<DeliveryChannel>;
  onChannelToggle: (channel: DeliveryChannel) => void;
}

export const DeliveryMethodCard: React.FC<DeliveryMethodCardProps> = ({
  deliveryChannels,
  onChannelToggle,
}) => {
  const theme = useTheme();
  const sectionStyles = getSectionStyles(theme);

  return (
    <Paper sx={sectionStyles.paper} elevation={0} variant="outlined">
      <Box sx={sectionStyles.header}>
        <Typography variant="subtitle1" fontWeight="bold">
          Delivery Method
        </Typography>
      </Box>
      <Box sx={sectionStyles.content}>
        <FormControl component="fieldset" fullWidth>
          <FormGroup row sx={{ gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={deliveryChannels.has('email')}
                  onChange={() => onChannelToggle('email')}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <EmailIcon fontSize="small" />
                  <span>Email</span>
                </Box>
              }
              sx={{ ml: 0 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={deliveryChannels.has('sms')}
                  onChange={() => onChannelToggle('sms')}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <SmsIcon fontSize="small" />
                  <span>SMS</span>
                </Box>
              }
              sx={{ ml: 0 }}
            />
          </FormGroup>
        </FormControl>
      </Box>
    </Paper>
  );
};
